import React from "react";
import { Box, Chip, Divider, Pagination, Typography } from "@mui/material";
import { CardsWrapper } from "./styles";
import { formatCurrency } from "../../../../utils/formatCurrency";
import {
	Settlement,
	SETTLEMENT_STATUS_COLOR,
	SETTLEMENT_STATUS_LABEL,
	SettlementStatusEnum
} from "../../../../store/services/affiliate/dto/affiliate.dto";

const AffiliateSettlementsCardsList = ({
	data,
	onCardClick,
	page,
	perPage,
	totalItems,
	onPageChange
}: {
	data: Settlement[];

	onCardClick: (settlement: Settlement) => void;
	page?: number;
	perPage?: number;
	totalItems?: number;
	onPageChange?: (page: number) => void;
}) => {
	return (
		<CardsWrapper>
			{(data || []).map(item => {
				return (
					<Box key={item.id} className={"card"} onClick={() => onCardClick(item)}>
						<Box my={1} display={"flex"} justifyContent={"space-between"} alignItems={"center"} px={1}>
							<Typography fontWeight={"bold"}>
								{item.firstName} {item.lastName}
							</Typography>
						</Box>
						<Divider />
						<Box p={1} pb={0} display={"flex"} flexDirection={"column"} gap={1}>
							<Box display={"flex"} flexDirection={"column"}>
								<Typography fontWeight={"bold"}>Business Name</Typography>
								<Typography>{item.businessName}</Typography>
							</Box>
							<Divider />
							<Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
								<Box display={"flex"} flexDirection={"column"} alignItems={"flex-start"} gap={1}>
									<Typography fontWeight={"bold"}>Total Sales</Typography>
									<Typography>{formatCurrency(item.totalSales, "EGP")}</Typography>
								</Box>
								<Box display={"flex"} flexDirection={"column"} alignItems={"flex-start"} gap={1}>
									<Typography fontWeight={"bold"}>Net Sales</Typography>
									<Typography>{formatCurrency(item.netSales, "EGP")}</Typography>
								</Box>
							</Box>
							<Divider />
							<Box className={"card-footer"} pb={1}>
								<Chip
									label={SETTLEMENT_STATUS_LABEL[item.status]}
									color={SETTLEMENT_STATUS_COLOR[item.status]}
									size={"small"}
								/>
							</Box>
						</Box>
					</Box>
				);
			})}
			{!!(page && perPage && totalItems) && (
				<Box p={2} display={"flex"} justifyContent={"flex-end"}>
					<Pagination
						page={page}
						count={Math.ceil(totalItems / perPage)}
						shape="rounded"
						onChange={(event: unknown, newPage: number) => {
							onPageChange && onPageChange(newPage);
						}}
					/>
				</Box>
			)}
		</CardsWrapper>
	);
};

export default AffiliateSettlementsCardsList;
